
try { ballot_scout_v2_frontend.core.init(); } catch (e) { console.error("An error occurred when calling (ballot-scout-v2-frontend.core/init)"); throw(e); }